import React, {useEffect, useState} from 'react';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {IconButton} from "@mui/material";
import UpdateEntityNameDialog from "../BRPortfolio/UpdateEntityNameDialog";
import UpdateEntityCycleDatesDialog from "./UpdateEntityCycleDatesDialog";
import BBIconEdit from "../../../assets/bbCustomIcons/BBIconEdit";
import {useSelector} from "react-redux";

const UpdateEntityMenu = ({entityId=null,})=>{

    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const [dateSelected, setDateSelected] = useState(null);

    const { loadingUpdateEntity, loadingUpdateEntitySettings, } = useSelector(({admin})=>admin);

    const handleClickMenu = (event)=>{
        setOpen(true);
        setAnchorEl(event.currentTarget);
    };

    const handleRequestClose = ()=>{
        setOpen(false);
        setAnchorEl(null);
    }

    open && console.log("This is open nwo for entityId", entityId, "open is set to", open, "anchorEl is ", anchorEl)

    // Object.values(Object.values(loadingUpdateEntity[entityId])).includes("true")
    // || Object.values(Object.values(loadingUpdateEntitySettings[entityId])).includes("true")
    useEffect(()=>{
        if(loadingUpdateEntity[entityId] || loadingUpdateEntitySettings[entityId]){

            console.log("One of these is loading")
             handleRequestClose()
            // if(loadingUpdateEntity[entityId]){
            //     if(Array.isArray(Object.values(loadingUpdateEntity[entityId]))){
            //         if(Object.values(Object.values(loadingUpdateEntity[entityId])).includes("true")){
            //             console.log("One of these is loading")
            //             handleRequestClose()
            //         }
            //     }
            // }else if(loadingUpdateEntitySettings[entityId]){
            //     if(Array.isArray(Object.values(loadingUpdateEntitySettings[entityId]))){
            //         if(Object.values(Object.values(loadingUpdateEntitySettings[entityId])).includes("true")){
            //             console.log("One of these is loading")
            //             handleRequestClose()
            //         }
            //     }
            } else{
                console.log("none of these are loading")
            }
    }, [loadingUpdateEntity, loadingUpdateEntitySettings])

    return(
        <span>

            <IconButton onClick={(event)=>handleClickMenu(event)} className={"mx-1 my-0 p-0 d-inline"}>
                            <BBIconEdit className={"d-block"}  />
                        </IconButton>

            <Menu className="user-info"
                  id="simple-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleRequestClose}
                  PaperProps={{
                      style: {
                          minWidth: 120,
                          paddingTop: 0,
                          paddingBottom: 0
                      }
                  }}
            >

                <MenuItem>
                    <UpdateEntityNameDialog entityId={entityId} adminView={true}/>
                </MenuItem>
                <MenuItem>
                    <UpdateEntityCycleDatesDialog
                        entityId={entityId}
                        dateToEdit={"next_cycle_datetime"}>
                        Update Next Cycle Date
                    </UpdateEntityCycleDatesDialog>
                </MenuItem>
                <MenuItem>
                    <UpdateEntityCycleDatesDialog
                        entityId={entityId}
                        dateToEdit={"ongoing_cycle_complete_datetime"}>
                        Update Current Cycle End Date
                    </UpdateEntityCycleDatesDialog>
                </MenuItem>

        </Menu>
        </span>

    )
}
export default UpdateEntityMenu;